import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CONST_URL_SEGEMENTS, PAYMENT_HANDSHAKE_HEADER } from 'paylink-constants';
import { AppErrors, NotFoundError } from 'errors';
import { PaymentHandshakeStoreService } from '../shared/services/payment-handshake/payment-handshake-store.service';
import {
  CreateClientPaymentTokenResponse,
  GetSignUpPaymentMethodResponse,
  WaiverMasterResponseList,
  SubscriptionSignUpOrderSummaryBillingDateResponse,
  SubscriptionSignUpOrderSummaryResponse,
  CreateClientWaiversRequest,
  CreateResponse,
  GetOrderStatusOfQuotation,
  StaffAvailabilityByAppointcategory,
  BookConsulationRequest,
  PlanAddonsResponse,
  AppointmentById,
  TourByUuuidResponse,
  AppointmentRescheduleRequest,
  TourRescheduleRequest,
  ReferralResponse,
  SubscriptionById,
  SaveTokenResponse,
} from 'models';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ProceedToPayCaptchaPayload {
  token: string;
  version: 'v3' | 'v2';
  action?: string;
}

@Injectable({
  providedIn: 'root',
})
export class SubscriptionSignupByUuidService {
  private http = inject(HttpClient);
  private readonly paymentHandshakeStore = inject(PaymentHandshakeStoreService);

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  httpPatchOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    }),
  };

  httpOptionsPlainText = {
    headers: new HttpHeaders({
      'Content-Type': 'text/plain',
    }),
  };

  GetCompany(BASE_URL: string, companyId: number): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_COMPANYBYID.replace(
        '{company_id}',
        companyId.toString(),
      );
    return this.getRequest(url);
  }

  GetTenant(BASE_URL: string, tenantId: number): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_TENANTBYID.replace(
        '{tenant_id}',
        tenantId.toString(),
      );
    return this.getRequest(url);
  }

  GetOrderSummary(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<SubscriptionSignUpOrderSummaryResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERSUMMARY.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetOrderDetails(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<GetOrderStatusOfQuotation> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERDETAILS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetOrderSubscriptionStatus(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<GetOrderStatusOfQuotation> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERDETAILS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetOrderSummaryPaymentTimeLine(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<SubscriptionSignUpOrderSummaryBillingDateResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_ORDERSUMMARYBILLINGOCCURENCE.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetWaivers(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<WaiverMasterResponseList> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_WAIVERS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetClientMandatoryField(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<string[]> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_CLIENT_MANDATORYFIELD.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetPaymentMethods(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<GetSignUpPaymentMethodResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_PAYMENTMETHODS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  PostWaivers(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    waiverPayload: CreateClientWaiversRequest,
  ) {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_WAIVERS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, waiverPayload);
  }

  ProceedToPay(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    payModeType: string,
    captcha?: ProceedToPayCaptchaPayload,
  ): Observable<GetSignUpPaymentMethodResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_PROCEEDTOPAYMENT.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    const params = { payment_modes: payModeType };
    return this.postRequest(url, params, captcha);
  }

  storePaymentHandshakeToken(signupUuid: string, token: string): void {
    this.paymentHandshakeStore.set(signupUuid, token);
  }

  clearPaymentHandshakeToken(signupUuid: string): void {
    this.paymentHandshakeStore.clear(signupUuid);
  }

  ProceedToPayTap(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    tokenInfo: any,
    captcha?: ProceedToPayCaptchaPayload,
  ): Observable<GetSignUpPaymentMethodResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_PROCEEDTOPAYMENT.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, tokenInfo, captcha);
  }

  SaveToken(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    token: string,
    internaltransactionid: string,
    is_token_required: boolean = false,
    is_authorized_card_on_file: boolean = false,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_SAVETOKEN.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    const params = {
      token: token,
      internaltransactionid: internaltransactionid,
      is_token_required: is_token_required,
      is_authorized_card_on_file: is_authorized_card_on_file,
    };
    return this.postRequest(url, params, undefined, UUID);
  }

  SaveTokenPay(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    token: string,
    internaltransactionid: string,
    optId: number,
    otpValue: string,
    tokenid: string,
  ): Observable<SaveTokenResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_SAVETOKEN.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    const params = {
      token: token,
      internaltransactionid: internaltransactionid,
      otpid: optId,
      otpcode: otpValue,
      tokenid: tokenid,
    };
    return this.postRequest(url, params, undefined, UUID);
  }

  SaveExternalTransactionId(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    externalTransactionId: string,
    internalTransactionId: string,
    is_authorized_card_on_file: boolean = false,
  ): Observable<CreateClientPaymentTokenResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_SAVEEXTERNALTRANSACTIONID.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    const params = {
      external_transaction_id: externalTransactionId,
      internal_transaction_id: internalTransactionId,
      is_authorized_card_on_file: is_authorized_card_on_file,
    };
    return this.postRequest(url, params, undefined, UUID);
  }

  UpdateClientInfo(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    body: any,
  ): Observable<CreateClientPaymentTokenResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.PUT_CLIENTINFO.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    const params = body;
    return this.patchRequest(url, params);
  }

  SendOtponPayment(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    tokenId: string,
  ): Observable<CreateResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.POST_OTP_TOKEN.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{tokenid}', tokenId);
    return this.getRequest(url);
  }

  GetStaffAvailability(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    appointmentCategoryId: number,
    allparams: any,
  ): Observable<StaffAvailabilityByAppointcategory> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_STAFF_AVAILABILITY_FOR_BOOKING.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{appointment_catagory_id}', appointmentCategoryId.toString());
    return this.getRequestWithParams(url, allparams);
  }

  GetStaffAvailabilityByAppointmentUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    appointmentCategoryId: number,
    allparams: any,
  ): Observable<StaffAvailabilityByAppointcategory> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_STAFF_AVAILABILITY_BY_APPOINTMENT_UUID.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{appointment_catagory_id}', appointmentCategoryId.toString());
    return this.getRequestWithParams(url, allparams);
  }

  GetStaffAvailabilityByTourUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    allparams: any,
  ): Observable<StaffAvailabilityByAppointcategory> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_STAFF_AVAILABILITY_BY_TOUR_UUID.replace(
        '{company_uuid}',
        companyUuid,
      ).replace('{tenant_uuid}', tenantUuid);
    return this.getRequestWithParams(url, allparams);
  }

  BookConsultation(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
    payload: BookConsulationRequest,
  ): Observable<StaffAvailabilityByAppointcategory> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.BOOK_CONSULTATION.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, payload);
  }

  getTenantSetting(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    UUID: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_TENANT_SETTINGS.replace(
        '{sigup_sts_uuid}',
        UUID,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetEligibleAddons(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    planId: number,
  ): Observable<PlanAddonsResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_ELIGIBLE_ADDONS.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{plan_id}', planId.toString());
    return this.getRequest(url);
  }

  GetBookedAppointment(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    appointmentUuid: string,
  ): Observable<AppointmentById> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_APPOINTMENT_BY_UUID.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{appt_uuid}', appointmentUuid.toString());
    return this.getRequest(url);
  }

  GetTourByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    tourUuid: string,
  ): Observable<TourByUuuidResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_TOUR_BY_UUID.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{tour_uuid}', tourUuid.toString());
    return this.getRequest(url);
  }

  RescheduleAppointment(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    appointmentUuid: string,
    payload: AppointmentRescheduleRequest,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.RESCHEDULE_APPOINTMENT_BY_UUID.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{appt_uuid}', appointmentUuid.toString());
    return this.postRequest(url, payload);
  }

  RescheduleTour(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    tourUuid: string,
    payload: TourRescheduleRequest,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.RESCHEDULE_TOUR_BY_UUID.replace(
        '{company_uuid}',
        companyUuid,
      )
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{tour_uuid}', tourUuid.toString());
    return this.postRequest(url, payload);
  }

  ValidateReferralCode(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    Uuid: string,
    referrredBy: string,
  ): Observable<ReferralResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.VALIDATE_REFERRAL_CODE_BY_CODE.replace(
        '{sigup_sts_uuid}',
        Uuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid)
        .replace('{referred_by}', referrredBy);
    return this.getRequest(url);
  }

  GetSubscriptionByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    subsUuid: string,
  ): Observable<SubscriptionById> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_SUBSCRIPTION_BY_UUID.replace(
        '{clt_subs_uuid}',
        subsUuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetSubscriptionInvoicesByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    subsUuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_SUBSCRIPTION_INVOICES_BY_UUID.replace(
        '{clt_subs_uuid}',
        subsUuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetInvoiceByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    uuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_INVOICE_BY_UUID.replace(
        '{invoice_uuid}',
        uuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetInvoicePdfByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    uuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.OPEN_API.GET_INVOICE_OPEN.replace('{uuid}', uuid)
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GenerateBalanceByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    uuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GENERATE_BALANCE_BY_UUID.replace(
        '{invoice_uuid}',
        uuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, null);
  }

  GetSalesReturnByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    uuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_SALESRETURN_BY_UUID.replace(
        '{salesreturn_uuid}',
        uuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  GetSalesReturnPdfByUuid(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    uuid: string,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_SALESRETURN_PDF_BY_UUID.replace(
        '{salesreturn_uuid}',
        uuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.getRequest(url);
  }

  InitiateUpdatePaymentMethod(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    subsUuid: string,
    payload: any,
  ): Observable<any> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.INITIATE_PAYMENT_METHOD_BY_UUID.replace(
        '{clt_subs_uuid}',
        subsUuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, payload);
  }

  GetPurchaseLinkStatus(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    subsUuid: string,
    payload: any,
  ): Observable<SaveTokenResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.GET_PURCHASE_LINK_STATUS_BY_UUID.replace(
        '{sigup_sts_uuid}',
        subsUuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, payload);
  }

  UpdatePaymentTimeout(
    BASE_URL: string,
    companyUuid: string,
    tenantUuid: string,
    subsUuid: string,
    payload: any,
  ): Observable<SaveTokenResponse> {
    const url: string =
      BASE_URL +
      CONST_URL_SEGEMENTS.SUBSCRIPTIONSIGNUP.UPDATE_PAYMENT_TIMEOUT.replace(
        '{sigup_sts_uuid}',
        subsUuid,
      )
        .replace('{company_uuid}', companyUuid)
        .replace('{tenant_uuid}', tenantUuid);
    return this.postRequest(url, payload);
  }

  patchRequest(url: string, body: any) {
    return this.http.patch(url, body, this.httpPatchOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      }),
    );
  }

  postRequest(
    url: string,
    body: any,
    captcha?: ProceedToPayCaptchaPayload,
    handshakeSignupUuid?: string,
  ) {
    return this.http
      .post(url, body, this.buildPostOptions(captcha, handshakeSignupUuid))
      .pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      }),
    );
  }

  private buildPostOptions(
    captcha?: ProceedToPayCaptchaPayload,
    handshakeSignupUuid?: string,
  ) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    if (captcha?.token) {
      headers = headers
        .set('X-Recaptcha-Token', captcha.token)
        .set('X-Recaptcha-Version', captcha.version);
      if (captcha.action) {
        headers = headers.set('X-Recaptcha-Action', captcha.action);
      }
    }

    if (
      handshakeSignupUuid &&
      environment.PAYMENT_HANDSHAKE_ENABLED !== false
    ) {
      const handshakeToken =
        this.paymentHandshakeStore.get(handshakeSignupUuid);
      if (handshakeToken) {
        headers = headers.set(PAYMENT_HANDSHAKE_HEADER, handshakeToken);
      }
    }

    return { headers };
  }

  getRequest(url: string) {
    return this.http.get(url, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      }),
    );
  }

  getRequestWithParams(url: string, allparams: any) {
    let parsedParams = new HttpParams();
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http
      .get(url, {
        headers: this.httpOptions.headers,
        params: parsedParams,
      })
      .pipe(
        map((res: any) => res),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        }),
      );
  }

  getRequestForPlainText(url: string) {
    return this.http.get(url, this.httpOptionsPlainText).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      }),
    );
  }
}
